<div class="container content-login" style="background-color: lightgray;" [formGroup]="userForm" autocomplete="off">
    <!--<div class="row py-3">-->
    <!--<div class="col">-->
    <!--<div class="input-group cursor" (click)="onBackClick()">-->
    <!--<div class="input-group-prepend">-->
    <!--<i class="fas fa-chevron-circle-left font-size-16" style="color: #1d2124;"></i>-->
    <!--</div>-->
    <!--<h4></h4>-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->
    <!--<div class=" cursor outline-0 text-center mb-3" [routerLink]="['/home']">-->
    <!--<div class="logo-background text-center" style="margin: 0 auto;width: 38%"></div>-->
    <!--</div>-->
    <div class="row logoheader">
        <div class="float-left position-absolute mx-2 my-1" style="z-index: 999">
            <div class="input-group" (click)="onBackClick()">
                <div class="input-group-prepend cursor">
                    <i class="fas fa-chevron-circle-left font-size-16" style="color: #fff;"></i>
                </div>
            </div>
        </div>
        <div class="col-12  cursor outline-0 text-center mt-1 mb-1">
            <div class="logo-background text-center" [routerLink]="['/home']" style="margin: 0 auto;width: 38%">
                <img src="./assets/images/OlarmewithMerchantMate.png" class="logo-background" />
            </div>
        </div>
    </div>

    <div class="row form-group mt-4 cart-phone-form-group mx-2 my-4">
        <div class="col-12">
            <ngx-intl-tel-input [cssClass]="'form-control border-0 form-control-lg'" [preferredCountries]="preferredCountries"
                [enableAutoCountrySelect]="false" [enablePlaceholder]="true" [searchCountryFlag]="true"
                [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]" [selectFirstCountry]="false"
                [selectedCountryISO]="selectedCountryISO" [maxLength]="15"
                [phoneValidation]="true" [separateDialCode]="separateDialCode" name="mobile" formControlName="mobile"
                [ngClass]="{'has-error': ((userForm.get('mobile').touched || userForm.get('mobile').dirty) &&  userForm.get('mobile').errors)}">
            </ngx-intl-tel-input>
        </div>
    </div>

    <div class="row" *ngIf="showOtp">
        <div class="col text-center">
            <label>Enter the 4 digit OTP</label>
        </div>
    </div>

    <div class="row form-group" *ngIf="showOtp">
        <div class="col"></div>
        <input id="pin1" style="border: 1px solid black !important;border-radius: 0px !important;"
            class="form-control form-control-lg text-center col  mx-2 border-0" type="text" max="1" maxlength="1"
            formControlName="pin1" (keypress)="numberOnly($event)" (keyup)="onKeyUpEvent(1, $event)"
            (focus)="onFocusEvent(1)" />

        <input id="pin2" style="border: 1px solid black !important;border-radius: 0px !important;"
         class="form-control form-control-lg text-center col mx-2 border-0" type="text" max="1"
            maxlength="1" formControlName="pin2" (keypress)="numberOnly($event)" (keyup)="onKeyUpEvent(2, $event)"
            (focus)="onFocusEvent(2)" />

        <input id="pin3" style="border: 1px solid black !important;border-radius: 0px !important;"
         class="form-control form-control-lg text-center col mx-2 border-0" type="text" max="1"
            maxlength="1" formControlName="pin3" (keypress)="numberOnly($event)" (keyup)="onKeyUpEvent(3, $event)"
            (focus)="onFocusEvent(3)" />

        <input id="pin4" style="border: 1px solid black !important;border-radius: 0px !important;"
         class="form-control form-control-lg text-center col mx-2 border-0" type="text" max="1"
            maxlength="1" formControlName="pin4" (keypress)="numberOnly($event)" (keyup)="onKeyUpEvent(4, $event)"
            (focus)="onFocusEvent(4)" />
            <div class="col"></div>
    </div>
    <div class="row form-group">
        <div class="col-6 ">
            <div [ngClass]="{'d-block': timerOn, 'd-none': !timerOn }"><span id="timer"></span> remaining</div>
        </div>
        <div class="col-6">
            <label *ngIf="!isOtpVerified && resendOTP" class="h6 small">Not recevied OTP yet click on <span
                    class="cursor text-primary" (click)="onresendOTPClick();">Resend
                    OTP</span></label>
        </div>
    </div>
    <div class="row">
        <div class="col" *ngIf="isOtpVerified">
            <div class="row form-group">
                <div class="col">
                    <label for="" class="font-weight-bold">New Password</label>
                    <input autocomplete="off" maxlength="50" type="password" class="form-control"
                        placeholder="New Password" formControlName="newpassword"
                        [ngClass]="{'has-error': ((userForm.get('newpassword').touched || userForm.get('newpassword').dirty) &&  userForm.get('newpassword').errors)}" />
                    <div class="">
                        <small class="text-orange">* Minimum 4 letters</small>
                    </div>
                    <!--<div class="row">-->
                    <!--<small id="password" class="form-text text-left cursor col" [popover]="popTemplate"-->
                    <!--popoverTitle="" [outsideClick]="true" placement="bottom">-->
                    <!--Click for password requirements-->
                    <!--</small>-->
                    <!--<ng-template #popTemplate>-->
                    <!--<p class="m-0">min of 6 & max of 20 chars</p>-->
                    <!--<p class="m-0">1 uppercase letter</p>-->
                    <!--<p class="m-0">1 lowercase letter</p>-->
                    <!--<p class="m-0">1 digit</p>-->
                    <!--</ng-template>-->
                    <!--</div>-->
                </div>
            </div>
            <div class="row form-group">
                <div class="col">
                    <label for="" class="font-weight-bold">Confirm Password</label>
                    <input autocomplete="off" maxlength="50" type="password" class="form-control"
                        placeholder="Confirm Password" formControlName="confirmpassword"
                        [ngClass]="{'has-error': ((userForm.get('confirmpassword').touched || userForm.get('confirmpassword').dirty) &&  userForm.get('confirmpassword').errors)}" />
                </div>
            </div>

            <div class="row form-group">
                <div class="col">
                    <button type="button" class="btn btn-outline-secondary btn-block bg-dark text-white"
                        (click)="onChangePasswordClick()" [disabled]="passwordChanged">Change Password</button>
                </div>
            </div>
        </div>
    </div>
    <div class="row form-group" *ngIf="!isOtpVerified">
        <div class="col text-center">
            <button type="button" class="btn text-white outline-0 box-shadow-none badge-pill" style="background-color: #3e97e6 !important;"
                (click)="onGetOTPClick()" [disabled]="sentOTP">Get OTP</button>
        </div>
    </div>
    <div class="row form-group">
        <div class="col text-danger text-center">
            {{errorMessage}}
        </div>
    </div>
    <div class="row form-group">
        <div class="col text-center">
            <div [ngClass]="{'d-block': redirect, 'd-none': !redirect }">redirecting in <span id="redirect"></span>
            </div>
        </div>
    </div>
    <div class="row form-group">
        <div class="col text-center">
            <div [ngClass]="{'d-block': redirect, 'd-none': !redirect }"><span class="text-primary cursor"
                    (click)="login()">click here</span> to login in, if not redirected in 5 secs</div>
        </div>
    </div>
</div>